var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vrm-installations-filter-indicator"},[_c('div',{staticClass:"vrm-installations-filter-indicator__label"},[(_vm.isFiltered)?_c('span',{domProps:{"innerHTML":_vm._s(
                _vm.$t('installationoverview.filter_results_count', {
                    i18nFallback: '<strong>{count}</strong> results match your filters.',
                    count: _vm.count,
                })
            )}}):_c('span',{domProps:{"innerHTML":_vm._s(
                _vm.$t('installationoverview.filter_results_all', {
                    i18nFallback: 'All <strong>{count}</strong> installations shown.',
                    count: _vm.count,
                })
            )}})]),(_vm.isFiltered)?_c('div',{staticClass:"vrm-installations-filter-indicator__action"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.clear()}}},[_vm._v("\n            "+_vm._s(_vm.$t('installationoverview.filter_button_clear_all', {
                    i18nFallback: 'Clear all filters',
                }))+"\n        ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }